import { render, staticRenderFns } from "./RightVerticalTabs.vue?vue&type=template&id=71ecc8b2"
import script from "./RightVerticalTabs.vue?vue&type=script&lang=js"
export * from "./RightVerticalTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports